<div class="message-wrapper">
    <epd-icon class="user-avatar" size="large" type="user-circle" />
    <p class="body-md-16-regular message-text">{{ message }}</p>
</div>
